import React from 'react';

import { PageId } from 'utils/ubi/pageId';
import assemblePath from 'utils/assemblePath';

import InternalLink, { HrefFunction, LinkProps } from './InternalLink';

const parentCategoryLinkBuilderFactory =
  (parentCategorySlug: string): HrefFunction =>
  (market, verticalParam) =>
    assemblePath(market, verticalParam, 'category', parentCategorySlug);

interface CategoryLinkProps extends LinkProps {
  parentCategorySlug: string;
}

const ParentCategoryLink = ({ parentCategorySlug, ...props }: CategoryLinkProps) => (
  <InternalLink toPage={PageId.Category} hrefFun={parentCategoryLinkBuilderFactory(parentCategorySlug)} {...props} />
);

export default ParentCategoryLink;
